import { Component, OnInit, Input } from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-aventibackground',
  templateUrl: './aventibackground.component.html',
  styleUrls: ['./aventibackground.component.css'],
})
export class AventibackgroundComponent implements OnInit {
  @Input() showversion = false;
  @Input() fill = false;
  mobileQuery: MediaQueryList;

  constructor(
    media: MediaMatcher
    ) {
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
  }

  ngOnInit(): void {}
}
